import { Controller } from '@hotwired/stimulus';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faUserCircle } from '@fortawesome/free-regular-svg-icons/faUserCircle';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons/faUserPlus';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons/faEllipsisH';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight';
import { faAnglesLeft } from '@fortawesome/free-solid-svg-icons/faAnglesLeft';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons/faAnglesRight';
import { faArrowCircleDown } from '@fortawesome/free-solid-svg-icons/faArrowCircleDown';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons/faTrashAlt';
import { faMars } from '@fortawesome/free-solid-svg-icons/faMars';
import { faVenus } from '@fortawesome/free-solid-svg-icons/faVenus';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons/faAsterisk';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons/faCalendarAlt';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faSquareFacebook } from '@fortawesome/free-brands-svg-icons/faSquareFacebook';
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons/faFilePdf';
import { faChartBar } from '@fortawesome/free-regular-svg-icons/faChartBar';
import { faToggleOn } from '@fortawesome/free-solid-svg-icons/faToggleOn';
import { faToggleOff } from '@fortawesome/free-solid-svg-icons/faToggleOff';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faCrown } from '@fortawesome/free-solid-svg-icons/faCrown';
import { faDna } from '@fortawesome/free-solid-svg-icons/faDna';
import { faRecycle } from '@fortawesome/free-solid-svg-icons/faRecycle';
import { faSortNumericDown } from '@fortawesome/free-solid-svg-icons/faSortNumericDown';
import { faDove } from '@fortawesome/free-solid-svg-icons/faDove';
import { faAddressCard } from '@fortawesome/free-regular-svg-icons/faAddressCard';
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt';
import { faBullseye } from '@fortawesome/free-solid-svg-icons/faBullseye';
import { faStickyNote } from '@fortawesome/free-regular-svg-icons/faStickyNote';
import { faEye } from '@fortawesome/free-regular-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons/faEyeSlash';
import { faBirthdayCake } from '@fortawesome/free-solid-svg-icons/faBirthdayCake';
import { faSortAlphaDown } from '@fortawesome/free-solid-svg-icons/faSortAlphaDown';
import { faSortAlphaUp } from '@fortawesome/free-solid-svg-icons/faSortAlphaUp';
import { faClock } from '@fortawesome/free-regular-svg-icons/faClock';
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar';
import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons/faShareAlt';
import { faCopy } from '@fortawesome/free-regular-svg-icons/faCopy';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { faGift } from '@fortawesome/free-solid-svg-icons/faGift';
import { faCodeCompare } from '@fortawesome/free-solid-svg-icons/faCodeCompare';
import { faRepeat } from '@fortawesome/free-solid-svg-icons/faRepeat';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons/faCircleCheck';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons/faCircleExclamation';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons/faCircleQuestion';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faYinYang } from '@fortawesome/free-solid-svg-icons/faYinYang';
import { faHandshakeAngle } from '@fortawesome/free-solid-svg-icons/faHandshakeAngle';
import { faPalette } from '@fortawesome/free-solid-svg-icons/faPalette';
import { faCartFlatbedSuitcase } from '@fortawesome/free-solid-svg-icons/faCartFlatbedSuitcase';
import { faHandHoldingHeart } from '@fortawesome/free-solid-svg-icons/faHandHoldingHeart';
import { faBatteryHalf } from '@fortawesome/free-solid-svg-icons/faBatteryHalf';
import { faCloudBolt } from '@fortawesome/free-solid-svg-icons/faCloudBolt';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faMobileScreen } from '@fortawesome/free-solid-svg-icons/faMobileScreen';
import { faApple } from '@fortawesome/free-brands-svg-icons';
import { faAndroid } from '@fortawesome/free-brands-svg-icons';

export default class extends Controller {
  initialize() {
    library.add(
      faHome,
      faUser,
      faUserCircle,
      faUserPlus,
      faSpinner,
      faEllipsisH,
      faChevronDown,
      faChevronUp,
      faChevronLeft,
      faChevronRight,
      faAngleLeft,
      faAngleRight,
      faAnglesLeft,
      faAnglesRight,
      faArrowCircleDown,
      faArrowUp,
      faArrowRight,
      faPlus,
      faInfoCircle,
      faDna,
      faRecycle,
      faSortNumericDown,
      faDove,
      faAddressCard,
      faTachometerAlt,
      faTrashAlt,
      faMars,
      faVenus,
      faEdit,
      faTrash,
      faTimes,
      faAsterisk,
      faCalendarAlt,
      faMapMarkerAlt,
      faInstagram,
      faSquareFacebook,
      faLinkedin,
      faYoutube,
      faGoogle,
      faTwitter,
      faGlobe,
      faFilePdf,
      faChartBar,
      faToggleOn,
      faToggleOff,
      faCheck,
      faMinus,
      faDownload,
      faCrown,
      faBullseye,
      faStickyNote,
      faEye,
      faEyeSlash,
      faBirthdayCake,
      faSortAlphaUp,
      faSortAlphaDown,
      faClock,
      faFilter,
      faStar,
      faHeart,
      faShareAlt,
      faCopy,
      faMagnifyingGlass,
      faGift,
      faCodeCompare,
      faRepeat,
      faCircleCheck,
      faCircleExclamation,
      faCircleQuestion,
      faBars,
      faYinYang,
      faHandshakeAngle,
      faPalette,
      faCartFlatbedSuitcase,
      faHandHoldingHeart,
      faBatteryHalf,
      faCloudBolt,
      faEnvelope,
      faMobileScreen,
      faApple,
      faAndroid,
    );
  }

  connect() {
    dom.watch();
  }
}
